import { render } from "./deptSelect.vue?vue&type=template&id=46303cfe&scoped=true"
import script from "./deptSelect.vue?vue&type=script&lang=js"
export * from "./deptSelect.vue?vue&type=script&lang=js"

import "./deptSelect.vue?vue&type=style&index=0&id=46303cfe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46303cfe"]])

export default __exports__